import { Caso, Custom } from 'portalba360'

export const state = {
    one: {},
    all: [],
    indicadores: {},
    AllProductos: [],
    AllMotivos: [],
    AllSubmotivos: [],
    producto: '',
    motivo: '',
    submotivo: '',
    caso: new Caso(),
    custom: new Custom()
};

export const mutations = {
    setOne: (state, data) => {
        state.one = data;
    },
    setAll: (state, data) => {
        if(data != undefined || data != null){
            state.all = data;
        }
    },
    setIndicadores: (state, data) => {
        if(data) {
            state.indicadores = Object.assign(data);
        }
    },
    setProductos: (state, data)=>{
        if(data){
            state.Allproductos = data
        }
    },
    setMotivos: (state, data)=>{
        if(data){
            state.Allmotivos = data
        }
    },
    setSubMotivos: (state, data)=>{
        if(data){
            state.Allsubmotivos = data
        }
    },
    setProducto: (state, data)=>{
        if(data || data === ''){
            state.producto = data
        }
    },
    setMotivo: (state, data)=>{
        if(data || data === ''){
            state.motivo = data
        }
    },
    setSubmotivo: (state, data)=>{
        if(data || data === ''){
            state.subMotivo = data
        }
    }
};

export const getters = {
    one: state => state.one,
    all: state => state.all,
    indicadores: state => state.indicadores,
    AllProductos: state => state.Allproductos,
    AllMotivos: state => state.Allmotivos,
    AllSubmotivos: state => state.Allsubmotivos,
    producto: state => state.producto,
    motivo: state => state.motivo,
    subMotivo: state => state.subMotivo,
};

export const actions = {
    async getAllRequests({commit, state}, data){
        commit('setLoading', 1, { root: true })
            try{
                let response = await state.caso.all(data)
                commit('setLoading', -1, { root: true })
                commit('setAll', response.data)
            }catch(e){
                return console.log(e)
            }
    },
    async getOneRequest({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.caso.one(data)
            commit('setLoading', -1, { root: true })
            commit('setOne', response.data[0])
            return response.data;
        }catch(e){
            return console.log(e)
        }
    },
    async createCaso({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.caso.add(data)
            commit('setLoading', -1, { root: true })
            commit('setOne', response.data)
            return response.data
        }catch(e){
            return console.log(e)
        }
    },
    async getIndicadores({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.caso.indicadores(data)
            commit('setLoading', -1, { root: true })
            commit('setIndicadores', response)
        }catch(e){
            return console.log(e)
        }
    },
    async getProductos({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.caso.productos(data)
            commit('setLoading', -1, { root: true })
            commit('setProductos', response.data)
            return response.data;
        }catch(e){
            return console.log(e)
        }
    },
    async getMotivos({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.caso.motivos(data)
            commit('setLoading', -1, { root: true })
            commit('setMotivos', response.data)
            return response.data;
        }catch(e){
            return console.log(e)
        }
    },
    async getSubMotivos({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.caso.subMotivos(data)
            commit('setLoading', -1, { root: true })
            commit('setSubMotivos', response.data)
            return response.data;
        }catch(e){
            return console.log(e)
        }
    },
    async custom({commit, state}, data){
        commit('setLoading', 1, { root: true })
        try{
            let response = await state.custom.service(data)
            commit('setLoading', -1, { root: true })
            commit('setOne', response.data)
            return response.data
        }catch(e){
            return console.log(e)
        }
    }
};
